"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreFooter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("..");
var TRANSLATIONS = {
    'en': {
        'opening_hours': 'Te llevamos tu pedido a home de 9:30 a 20:30 (M-F) • Compra rápida de tus productos habituales'
    },
    'es': {
        'opening_hours': 'Te llevamos tu pedido a casa de 9:30 a 20:30 (L-V) • Compra rápida de tus productos habituales'
    },
    'fr': {
        'opening_hours': 'Livraison à domicile entre 09H00 et 13H00 du lundi au vendredi • Commande rapide de tes produits préférés'
    },
    'it': {
        'opening_hours': 'Te llevamos tu pedido a casa de 9:30 a 20:30 (L-V) • Compra rápida de tus productos habituales'
    },
};
var Aside = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow-x: hidden;\n  width: 100vw;\n\n  .marquee {\n    background-color: ", ";\n  }\n\n  .marquee-item-footer {\n    color: ", ";\n  }\n"], ["\n  overflow-x: hidden;\n  width: 100vw;\n\n  .marquee {\n    background-color: ", ";\n  }\n\n  .marquee-item-footer {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.creamlight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.background;
});
exports.PreFooter = (0, react_1.memo)(function (_a) {
    var services = _a.services;
    return services ? ((0, jsx_runtime_1.jsx)(Aside, { children: (0, jsx_runtime_1.jsx)(__1.MarqueeSlider, { data: services.replace(/&nbsp;/g, ' '), uniqueClass: 'marquee-item-footer' }) })) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
});
var templateObject_1;
